import type { Product } from '../models/Product';
import { apiClient } from '../../services/ApiClient';
import type {
    ProductQueryCombinations,
    ProductQuery,
    ProductQuerySimilar
} from '../models/ProductQuery';
/**
 * Get a list of products based on a query.
 */
export function getProductList(productQuery: ProductQuery): Promise<Product[]> {
    switch (productQuery.queryType) {
        case 'combinations':
            return getCombinations(productQuery);
        case 'similar':
            return getSimilar(productQuery);
        default:
            throw new Error(`Unknown query type: ${productQuery['queryType']}`);
    }
}

async function getCombinations(
    productQuery: ProductQueryCombinations
): Promise<Product[]> {
    const result = await apiClient.product.productSearchCombinations({
        body: {
            productIds: productQuery.combineWithProductIds,
            maxGroups: 4,
            maxGroupSize: 8,
            sortBy: 'relevance'
        }
    });
    // Mix products from all groups in a non-consecutive manner
    const groups = result.jsonResult.groups;
    const maxProducts = groups.reduce(
        (sum, group) => sum + group.products.length,
        0
    );
    const products: Product[] = [];

    for (let i = 0; i < maxProducts; i++) {
        const group = groups[i % groups.length];
        const product = group.products[Math.floor(i / groups.length)];
        if (product) {
            products.push(product);
        }
    }

    return products;
}

async function getSimilar(
    productQuery: ProductQuerySimilar
): Promise<Product[]> {
    const result = await apiClient.product.productSearchSimilar({
        body: {
            productIds: productQuery.similarToProductIds,
            pageSize: 24,
            sortBy: 'relevance'
        }
    });
    return result.jsonResult.products;
}
